import { Avatar } from '../../../layout/Avatar.jsx';
import { Icon } from '../../../layout/Icon.jsx';
import { formatIQD } from '../../../shared/format.js';
import { usePosState } from '../hooks/usePosState.js';

export function SuspendBanner() {
  const link = usePosState((s) => s.link);
  const unlink = usePosState((s) => s.unlink);

  if (!link) return null;

  const reasonLabel =
    link.linkedBy === 'card' ? 'كارت ممسوح' :
    link.linkedBy === 'child_search' ? 'بحث الطفل' :
    'مرتبطة';

  return (
    <div className="rounded-[12px] border border-orange/30 bg-[#FFF6EB] p-3 flex items-center gap-3">
      <Avatar
        size="md"
        name={link.childName || '?'}
        id={link.childId || link.cardUid}
        src={link.photoUrl || null}
      />
      <div className="flex-1 min-w-0">
        <div className="text-[10px] text-ink-3 flex items-center gap-1.5 flex-wrap">
          <span>مرتبطة بـ • {reasonLabel}</span>
          {link.subscriptionOnly ? (
            <span
              className="rounded-full px-1.5 py-[1px] font-bold"
              style={{ background: '#CFFAFE', color: '#0E7490' }}
            >
              مشترك شهري{link.subscriptionPlan ? ` — ${link.subscriptionPlan}` : ''} • خارج القاعة
            </span>
          ) : null}
        </div>
        <div className="font-bold text-[14px] truncate">{link.childName || '—'}</div>
        <div className="text-[11px] text-ink-3 flex items-center gap-2 flex-wrap">
          <span dir="ltr" style={{ fontFamily: 'monospace' }}>{link.cardUid || '—'}</span>
          {typeof link.cardBalance === 'number' ? (
            <span>• رصيد {formatIQD(link.cardBalance)}</span>
          ) : null}
        </div>
      </div>
      <button
        type="button"
        className="btn btn-ghost text-red"
        onClick={unlink}
        title="إلغاء الربط"
      >
        <Icon name="x" size={14} /> إلغاء الربط
      </button>
    </div>
  );
}
